module.exports = function capabilitiesFromHash({ supportsWebRTC }) {
  return {
    supportsWebRTC: supportsWebRTC === 'true' || supportsWebRTC === true,
  };
};



// WEBPACK FOOTER //
// ./src/js/ot/connectionCapabilities.js